import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconNuclearDanger$1 = /*@__PURE__*/ proxyCustomElement(class WppIconNuclearDanger extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-nuclear-danger", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.89957 2.62663C6.69251 2.26794 6.2339 2.14498 5.87517 2.35199C3.32159 3.82556 1.74879 6.55015 1.75 9.49838C1.75017 9.91248 2.08591 10.2481 2.5 10.2481H7.00008C7.41429 10.2481 7.75008 9.91229 7.75008 9.49808C7.75008 8.66657 8.20091 7.93894 8.87569 7.54854C9.23398 7.34125 9.35659 6.88288 9.14964 6.5244L6.89957 2.62663ZM6.32513 8.74808H3.29138C3.49938 6.87813 4.481 5.17756 5.99624 4.0621L7.51375 6.69088C6.91727 7.21965 6.49003 7.93617 6.32513 8.74808ZM14.1264 16.6475C14.485 16.4403 14.6079 15.9817 14.4008 15.623L12.1502 11.7255C11.9432 11.367 11.485 11.244 11.1263 11.4507C10.4508 11.8398 9.59527 11.8665 8.87516 11.4507C8.51644 11.2436 8.05775 11.3665 7.85064 11.7252L5.60061 15.6224C5.39356 15.981 5.51633 16.4396 5.87486 16.6468C8.4275 18.1219 11.5735 18.1221 14.1264 16.6475ZM11.1881 13.059L12.7059 15.6876C10.9823 16.4421 9.01875 16.4419 7.29533 15.687L8.81221 13.0597C9.59779 13.3229 10.4319 13.3111 11.1881 13.059ZM13.1007 2.62687C13.3077 2.26818 13.7663 2.14523 14.1251 2.35223C16.6786 3.8258 18.2514 6.5504 18.2502 9.49863C18.2501 9.91272 17.9143 10.2483 17.5002 10.2483H13.0001C12.5859 10.2483 12.2501 9.91253 12.2501 9.49832C12.2501 8.66681 11.7993 7.93918 11.1245 7.54878C10.7662 7.34149 10.6436 6.88313 10.8506 6.52464L13.1007 2.62687ZM14.004 4.06235L12.4865 6.69112C13.083 7.21989 13.5102 7.93641 13.6751 8.74832H16.7088C16.5008 6.87837 15.5192 5.1778 14.004 4.06235ZM10 10.75C10.6904 10.75 11.25 10.1904 11.25 9.5C11.25 8.80964 10.6904 8.25 10 8.25C9.30964 8.25 8.75 8.80964 8.75 9.5C8.75 10.1904 9.30964 10.75 10 10.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-nuclear-danger-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-nuclear-danger", "wpp-icon-nuclear-danger-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-nuclear-danger-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-nuclear-danger-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconNuclearDanger$1);
      }
      break;
  } });
}

const WppIconNuclearDanger = WppIconNuclearDanger$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconNuclearDanger, defineCustomElement };
